(() => {
 const init = (root=document) => {
  root.querySelectorAll('.sat-gallery').forEach(gallery=>{
   if(gallery.dataset.ready)return;gallery.dataset.ready='true';
   const buttons=[...gallery.querySelectorAll('.sat-thumb')];
   let active=0;
   const show=(index)=>{
    const i=(index+buttons.length)%buttons.length,button=buttons[i]; active=i;
    const thumb=button.querySelector('img'),main=gallery.querySelector('.sat-gallery-main img');
    main.src=thumb.dataset.fullSrc||thumb.src;main.srcset=thumb.dataset.fullSrcset||thumb.srcset;main.alt=thumb.alt;
    buttons.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
    gallery.querySelector('[data-sat-slide-count]').textContent=`${i+1} / ${buttons.length}`;
    button.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
   };
   buttons.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
   gallery.querySelector('[data-sat-prev]')?.addEventListener('click',()=>show(active-1));
   gallery.querySelector('[data-sat-next]')?.addEventListener('click',()=>show(active+1));
   gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1));}});
   const stage=gallery.querySelector('.sat-gallery-main');let start=null;
   stage.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});
   stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(active+(dx<0?1:-1));start=null;},{passive:true});
  });
  root.querySelectorAll('[data-sat-packs]').forEach(packs=>{
   if(packs.dataset.ready)return;packs.dataset.ready='true';
   const section=packs.closest('.sat-product'), quantity=section.querySelector('[data-sat-quantity]');
   packs.addEventListener('change',event=>{
    if(!event.target.matches('input[type=radio]'))return;
    quantity.value=event.target.value;
    section.querySelector('[data-sat-offer-note]').textContent=quantity.value==='2'?'Two Color Veil lipsticks. One lovely price.':'One Color Veil lipstick, just for you.';
   });
  });
 };
 document.addEventListener('DOMContentLoaded',()=>init());
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
